import { useTranslation } from 'react-i18next';
import { OnboardingSpotlight } from './OnboardingSpotlight';

interface PrePromptsTourStepProps {
    onNext: () => void;
}

export const PrePromptsTourStep = ({ onNext }: PrePromptsTourStepProps) => {
    const { t } = useTranslation();
    return (
        <OnboardingSpotlight
            targetSelector='[data-onboarding="pre-prompts"]'
            title={t('chat.onboarding.prePrompts.title')}
            description={t('chat.onboarding.prePrompts.description')}
            buttonText={t('chat.onboarding.prePrompts.button')}
            onNext={onNext}
        />
    );
};
